<div class="p-6 w-full">

  <form  class="row"><h3 class="dark:text-gray-100">Tarifas Por Carril</h3>
    <div class="dark:text-gray-100 dark:bg-transparent align-middle flex"  style="width: 100%;" >
      <span class="w-1/3 text-right ml-auto inline-block align-middle pt-5 mr-3 ">Nombre de tarifa</span>
    <input  type="text" class="w-1/3 flex text-left estilo-dark dark:text-gray-100 dark:bg-gray-700 ml-auto tarifaNombre" (change)="getNombreTarifa($event);"  >
    </div>
    <div *ngFor="let tarifaCarril of nuevaTarifaPorCarril;let i = index" class="w-full grid grid-cols-4 gap-4">
        <div class="col-span-4" >
          <label>Carril(es)</label>
          <select (change)="actualizarJsonNuevaTarifa(i, 'carril', 0, $event)" multiple class="col-start-1 row-start-1 w-full rounded-md bg-white/5 py-1.5 pr-8 pl-3 text-base *:bg-gray-800 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 ">
            <option *ngFor="let opcion of carriles" [value]="opcion.id">{{opcion.nombre}}</option>
          </select>
        </div>
        <div class="dark:text-gray-100 dark:bg-transparent align-middle flex " *ngFor="let tarifa of dataTarifas">
          <span class="w-2/3 text-right ml-auto inline-block align-middle pt-5 mr-3">{{tarifa.vehiculo.tipo}}</span>
          <input  type="number" class="w-1/3 flex text-left estilo-dark dark:text-gray-100 dark:bg-gray-700 ml-auto tarifasEntries" (change)="actualizarJsonNuevaTarifa(i, 'tarifa', tarifa.id, $event)" min="0" value="0" step="1" >
        </div>

        <hr class="col-span-4">
    </div>


    <hr>
  </form>
  <div class="items-end flex">
    <button *ngIf="nombre!='' && nombre!=null" class="flex estilo-dark dark:bg-transparent  dark:text-white dark:hover:border-blue-600 hover:border-blue-600" (click)="saveTarifas()">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"  >
        <path stroke-linecap="round" stroke-linejoin="round" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
      </svg>
      <span class="ml-2">
        Guardar
      </span>
    </button>
    <button class="flex estilo-dark dark:bg-transparent  dark:text-white dark:hover:border-green-600 hover:border-blue-600" (click)="agregarTarifas()">
      <ion-icon slot="start" name="add"></ion-icon>
      <span class="ml-2">
        Agregar
      </span>
    </button>
  </div>
</div>
